import { Http } from 'packages/workspace/modules/prelude/http';
import type { IDashBoardDocument } from '../models/dashBoard-document';
import type { IDashBoardContent } from '../models/dashbooard-content';
import type { ResponseFormat } from '../models/global-models';

export const FETCH_DASHBOARD_CONTENT = 'fetchDashboardContent';

export const fetchDashboardContent = async (type: string): Promise<Array<IDashBoardContent>> => {
  return await Http.Request<ResponseFormat<Array<IDashBoardContent>>>('GET', `/workspaces/api/v1/dashboard-contents.get?type=${type}`).then((res) => res.data);
};

export const fetchDashboardDocument = async (type: string): Promise<Array<IDashBoardDocument>> => {
  return await Http.Request<ResponseFormat<Array<IDashBoardDocument>>>('GET', `/workspaces/api/v1/dashboard-documents.list?type=${type}`).then((res) => res.data);
};
